// extracted by mini-css-extract-plugin
export default {"mask":"AppMobileMenu__mask___MB1hc","container":"AppMobileMenu__container___Y3N_h","bodyContent":"AppMobileMenu__bodyContent___h5egj","isOpen":"AppMobileMenu__isOpen___w5vBf"};